<template>
  <div>
    <global-table
      :table-data="productPurchaseList"
      :loading="loadingPurchase"
      :per-page="10"
      :table-detail="tableDetail"
      :bordered="true"
      :hover="true"
      :striped="false"
      :id-modals="'purchasePricingForm'"
      :row-edit="purchasePricingForm"
      :redirect-detail="false"
      :show-add-button="true"
      :remove-button="true"
      :fields="fieldsPricing"
      addButton="Update Harga Beli"
      @editForm="editPricingForm"
      @resetForm="resetPricingForm"
      @removeForm="removePricingForm"
    ></global-table>

    <b-modal
      ref="myModalDetail2Ref"
      id="purchasePricingForm"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">Form Product Purchase Pricing</h3>
      </div>

      <b-form id="pricingForm" validated novalidate>
        <div v-if="!loadingSubmitModal">
          <b-row>
            <b-col sm="4">
              <b-form-group label-for="start_date" label="Tanggal Awal">
                <v-date-picker
                  id="start_date"
                  :input-props="{
                    class: 'form-control',
                    placeholder: 'Tanggal Awal',
                    required: '',
                  }"
                  :state="!$v.purchasePricingForm.start_date.$invalid"
                  v-model="$v.purchasePricingForm.start_date.$model"
                ></v-date-picker>
                <div
                  v-if="$v.purchasePricingForm.start_date.$invalid"
                  class="invalid-feedback-custom"
                >
                  Tanggal berlaku harga pembelian ini.
                </div>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group label-for="price" label="Harga Beli Produk">
                <b-form-input
                  id="price"
                  type="number"
                  v-model="$v.purchasePricingForm.price.$model"
                  :state="!$v.purchasePricingForm.price.$invalid"
                  placeholder="Harga"
                  min="0"
                  required
                ></b-form-input>
                <b-form-invalid-feedback
                  >Harga Beli Produk harus di isi.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <loading></loading>
        </div>
      </b-form>

      <div slot="modal-footer" class="float-right">
        <div v-if="!loadingSubmitModal">
          <b-button
            type="button"
            size="sm"
            variant="danger"
            @click="cancelAddPricing"
          >
            <i class="fa fa-undo"></i> Back </b-button
          >&nbsp;
          <b-button
            v-if="isEdit===0"
            type="button"
            size="sm"
            variant="primary"
            @click="submitAddPricing"
            :disabled="$v.purchasePricingForm.$invalid"
          >
            <i class="fa fa-save"></i> Save
          </b-button>

          <b-button
            v-if="isEdit===1"
            type="button"
            size="sm"
            variant="primary"
            @click="updatePurchasePricing"
            :disabled="$v.purchasePricingForm.$invalid"
          >
            <i class="fa fa-save"></i> Save
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";
import * as moment from "moment";

export default {
  name: "product-purchase-price",
  components: {
    globalTable,
    ModelSelect,
    loading,
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true,
    },
    productId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      removeButton: true,
      productPurchaseList: [],
      listCustomerGroup: [],
      listPricingUnit: [],
      listProductGroup: [],
      fieldsPricing: [
        { key: "price", label: "Harga Beli (Box)", sortable: true },
        { key: "start_date_name", label: "Berlaku Dari" },
        { key: "end_date_name", label: "Sampai" },
        { key: "flag_name", label: "Status" },
        { key: "action_purchase_price", label: "Action", class: "text-center width-100" },
      ],
      listFlagStatus: [
        { value: "1", text: "Active" },
        { value: "2", text: "Not Active" },
      ],
      purchasePricingForm: interfaces.purchase_pricing,
      loadingPurchase: false,
      loadingSubmitModal: false,
      isEdit: 0,
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  validations: {
    purchasePricingForm: {
      start_date: { required },
      price: { required },
      end_date: {},
      product_id: {},
    },
  },
  methods: {
    init: function (produk_id) {
      this.loadingPurchase = true;
      this.getAllProductDetail(produk_id);
    },
    getAllProductDetail(produk_id) {
      this.axios
        .get("web/product/purchase-price/" + produk_id)
        .then((response) => {
          //this.purchasePricingForm = response.data.data;
          this.productPurchaseList = response.data.data;
        })
        .catch((error) => {
          this.expired(error);
        })
        .finally(() => {
          this.loadingPurchase = false;
        });
    },

    editProduct: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin mengubah produk ?")) {
        this.axios
          .put("web/product/change-detail/", this.productForm)
          .then((response) => {
            let _detailData = response.data.data;
            this.showInfoNotification({
              title: "Ubah Produk",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Change product");
          })
          .finally(() => {
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    editPricingForm: function (data) {
      this.resetPricingForm();
      this.isEdit=1;
      this.purchasePricingForm = data;
      this.purchasePricingForm.start_date = new Date(data.start_date);
    },
    removePricingForm: function (data) {
      console.log(data);
    },
    back: function () {
      this.$router.go(-1);
    },
    resetPricingForm: function () {
      for (var a in interfaces.purchase_pricing) {
        interfaces.purchase_pricing[a] = null;
      }
      this.purchasePricingForm = interfaces.purchase_pricing;
    },

    cancelAddPricing: function () {
    this.isEdit=0;
    this.$refs.myModalDetail2Ref.hide();
    },
    submitAddPricing: function (evt) {
      evt.preventDefault();
      let purchasePricingProduct = this.purchasePricingForm;
      purchasePricingProduct.product_id = this.productId;
      purchasePricingProduct.start_date = moment(this.purchasePricingForm.start_date).format('YYYY-MM-DD');

      if (confirm("Apakah anda ingin menambahkan harga produk ini ?")) {
        this.loadingSubmitModal = true;
        this.axios
          .post("web/product/add-purchase-pricing-product/", purchasePricingProduct)
          .then((response) => {
            let _detailData = response.data.data;
            this.showInfoNotification({
              title: "Tambah harga beli produk",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Add pricing product");
          })
          .finally(() => {
            this.loadingSubmitModal = false;
            this.cancelAddPricing();
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    updatePurchasePricing: function(evt) {
      evt.preventDefault();
      let purchasePricingProduct = this.purchasePricingForm;
      purchasePricingProduct.product_id = this.productId;
      purchasePricingProduct.start_date = moment(this.purchasePricingForm.start_date).format('YYYY-MM-DD');

      if (confirm("Apakah anda ingin mengubah harga produk ini ?")) {
        this.loadingSubmitModal = true;
        this.axios
          .put("web/product/update-purchase-pricing-product/", purchasePricingProduct)
          .then((response) => {
            let _detailData = response.data.data;
            this.showInfoNotification({
              title: "Tambah harga beli produk",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Add pricing product");
          })
          .finally(() => {
            this.loadingSubmitModal = false;
            this.cancelAddPricing();
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
</style>
